<template>
  <div class="field">
    <label class="label" v-if="to.label" :for="to.id ? to.id : null">{{
      to.label
    }}</label>
    <table class="table is-striped">
      <thead>
        <th>Product Code</th>
        <th width="20%">Quantity</th>
        <th width="20%">Price</th>
        <th width="15%"></th>
      </thead>
      <tbody>
        <tr v-for="(row, index) in model.productTable">
          <td>
            <div class="select">
              <select
                :class="to.classes"
                :id="to.id ? to.id : null"
                v-model="row.productCode"
                name="product_code"
                @blur="onBlur"
                @focus="onFocus"
                @click="onClick"
                @change="onChange"
                @keyup="onKeyup"
                @keydown="onKeydown"
                v-formly-atts="to.atts"
              >
                <option
                  v-for="option in options"
                  :value="option.value || option"
                  >{{ option.label || option }}</option
                >
              </select>
            </div>
          </td>
          <td>
            <div>
              <div class="control field-options">
                <input
                  type="tel"
                  v-model="row.quantity"
                  class="input"
                  name="quantity"
                  required
                />
              </div>
            </div>
          </td>
          <td>
            <div>
              <div class="control field-options">
                <input
                  type="tel"
                  v-model="row.price"
                  class="input"
                  name="price"
                  required
                />
              </div>
            </div>
          </td>
          <td>
            <div style="width:30px;">
              <i
                class="fa fa-plus-square-o mr1 pointer"
                title="Add"
                @click="addRow()"
              ></i>
              <i
                v-if="index > 0"
                class="fa fa-minus-square-o mr1 pointer"
                title="Remove"
                @click="removeRow(index)"
              ></i>
              <i
                class="fa fa-minus-square-o has-text-grey-light"
                v-if="index == 0"
              ></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <error-display :form="form" :field="field.key"></error-display>
  </div>
</template>

<script>
import baseField from "./baseField";

export default {
  mixins: [baseField],

  data() {
    return {
      options: [
        { value: "INTP", label: "Interview – Physician" },
        { value: "INTM", label: "Interview – Midlevel Provider" },
        { value: "KWDP", label: "Keyword Premium" },
        { value: "KWDS", label: "Keyword Standard" }
      ]
    };
  },

  methods: {
    addRow() {
      this.model.productTable.push({
        productCode: null,
        quantity: 1,
        price: 1000
      });
    },
    removeRow(index) {
      this.model.productTable.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.field {
  padding-top: 20px;

  input {
    text-align: center;
  }
}
</style>
